import Api from './api';

export default {
  getEpics: () => Api.get('epics'),
  getEpicDetails: (id) => Api.get(`epics/${id}`),
  getFeatDetails: (featId) => Api.get(`epics/feats/${featId}`),
  getCurrentFeat: () => Api.get('epics/current'),
  getAllFeats: () => Api.get('epics/feats'),
};
